import gql from 'graphql-tag'
import {
	media as mediaFragment
} from './fragments'

export default gql`
mutation updateManyMedia($idArr: [ID]!, $fields: MediaFields!) {
	cashAssist {
		updateManyMedia(idArr: $idArr, fields: $fields) {
			id
			mod_ver
			...mediamain
			cashRegisterId
		}
	}
}
${mediaFragment}`

